import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Box, Link, ListItem, Typography } from "@mui/material";
import type { HunterPrerequisiteItem } from "Components/Hunter/Prerequisites/types";
import { PrerequisiteCompletionStatus } from "Infrastructure/Api/Api";

type Props = HunterPrerequisiteItem;

export const PrerequisiteItem = ({
  description,
  completionStatus,
  link,
}: Props) => {
  const isCompleted =
    completionStatus !== PrerequisiteCompletionStatus.NotCompleted;

  return (
    <ListItem disableGutters sx={{ py: 1.5 }}>
      <Box display="flex" alignItems="flex-start" gap={1.5}>
        {isCompleted ? (
          <CheckCircleOutlineIcon
            color="primary"
            sx={{ fontSize: 20, mt: 0.25 }}
          />
        ) : (
          <RadioButtonUncheckedIcon
            sx={{
              fontSize: 20,
              mt: 0.25,
              color: "text.disabled",
              opacity: 0.5,
            }}
          />
        )}
        <Typography component="span">
          {description}
          {link && (
            <>
              {" "}
              <Link
                href={link.href}
                target={link.external ? "_blank" : undefined}
                rel={link.external ? "noopener noreferrer" : undefined}
                sx={{ fontWeight: 500 }}
              >
                {link.text}
              </Link>
            </>
          )}
        </Typography>
      </Box>
    </ListItem>
  );
};
